export class YaStorage {

    public static saveUniqueId(uniqueId: string | null): void {
        try {
            if (!uniqueId) {
                return;
            }

            if (localStorage) {
                let yaIds = localStorage.getItem('ya_ids');
                if (!yaIds) {
                    localStorage.setItem('ya_ids', uniqueId);
                } else if (yaIds && yaIds.length > 0 && !yaIds.includes(uniqueId)) {
                    localStorage.setItem('ya_ids', yaIds + ',' + uniqueId);
                }
            }
        } catch (ignore) {}
    }

    public static updateMaxLevel(level: number): void {
        try {
            if (localStorage) {
                let yaMaxLevelStr = localStorage.getItem('ya_level');
                if (yaMaxLevelStr && yaMaxLevelStr.length > 0) {
                    let maxLevel: number = Number(yaMaxLevelStr);
                    if (level > maxLevel) {
                        localStorage.setItem('ya_level', String(level));
                        localStorage.setItem('max_level_updated_at', String(Date.now()));
                    }
                } else {
                    localStorage.setItem('ya_level', String(level));
                    localStorage.setItem('max_level_updated_at', String(Date.now()));
                }
            }
        } catch (ignore) {}
    }

    public static setChooseRejected(): void {
        try {
            if (localStorage) {
                localStorage.setItem('choose_rejected_at', String(Date.now()));
            }
        } catch (ignore) {}
    }

    public static isChooseRejected(): boolean {
        try {
            if (localStorage) {
                let max_level_updated_at = localStorage.getItem('max_level_updated_at');
                let choose_rejected_at = localStorage.getItem('choose_rejected_at');

                if (!max_level_updated_at) {
                    return true;
                }

                if (!choose_rejected_at) {
                    return false;
                }

                let max_level_updated_at_ts = new Date(Number(max_level_updated_at)).getTime();
                let choose_rejected_at_ts = new Date(Number(choose_rejected_at)).getTime();

                return choose_rejected_at_ts > max_level_updated_at_ts;
            }
        } catch (ignore) {}

        return true;
    }

    // localStorage.setItem('wtf1', String(Date.now()));
    // let choose_rejected_at = localStorage.getItem('wtf1');
    // console.log(choose_rejected_at);
    // let choose_rejected_at_ts = new Date(Number(choose_rejected_at!));
    // console.log(choose_rejected_at_ts.getTime());
    // console.log('================ asdasd');

    public static getAllIds(): string {
        try {
            if (localStorage) {
                let yaIds = localStorage.getItem('ya_ids');
                if (yaIds) {
                    return yaIds;
                }
            }
        } catch (ignore) {}
        return '';
    }

    public static getMaxLevel(): number {
        try {
            if (localStorage) {
                let yaMaxLevelStr = localStorage.getItem('ya_level');
                if (yaMaxLevelStr && yaMaxLevelStr.length > 0) {
                    return Number(yaMaxLevelStr);
                }
            }
        } catch (ignore) {}
        return 0;
    }

    public static setUsedRemap(): void {
        try {
            if (localStorage) {
                localStorage.setItem('used_remap', "true");
            }
        } catch (ignore) {}
    }

    public static isUsedRemap(): boolean {
        try {
            if (localStorage) {
                let val = localStorage.getItem('used_remap');
                return !!val && val.length > 0;
            }
        } catch (ignore) {}
        return false;
    }
}